export const OTHER = '#6A6C7C';
export const NEUTRAL = '#E7E7E7';
export const TIE = '#666666';

export const YES = '#73a8a7';
export const NO = '#e9c368';
export const ELDER = '#bba2c7';
export const KILEY = '#f6a0a1';
export const FAULCONER = '#aec837';
export const JENNER = '#f2da7b';
export const OSE = '#b75a36';
export const COX = '#a6c8e1';
export const PAFFRATH = '#e5bb5b';

const colorLookup = new Map([
  ['polid-2', YES],
  ['polid-3', NO],
  ['polid-69750', ELDER],
  ['polid-69756', KILEY],
  ['polid-69751', FAULCONER],
  ['polid-69755', JENNER],
  ['polid-9', OSE],
  ['polid-66651', COX],
  ['polid-69746', PAFFRATH],
]);

export function getColor(/** @type {string} */ apId) {
  return colorLookup.get(apId) || OTHER;
}
